var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 5.40594L20.79 0L19.035 2.07921L25.245 7.48515L27 5.40594ZM7.965 2.21782L6.21 0.138613L0 5.40594L1.755 7.48515L7.965 2.21782ZM14.175 8.59406H12.15V16.9109L18.495 20.9307L19.575 19.2673L14.175 15.9406V8.59406ZM13.5 3.0495C6.75 3.0495 1.35 8.59406 1.35 15.5248C1.35 22.4554 6.75 28 13.5 28C20.25 28 25.65 22.4554 25.65 15.5248C25.65 8.59406 20.25 3.0495 13.5 3.0495ZM13.5 25.2277C8.235 25.2277 4.05 20.9307 4.05 15.5248C4.05 10.1188 8.235 5.82178 13.5 5.82178C18.765 5.82178 22.95 10.1188 22.95 15.5248C22.95 20.9307 18.765 25.2277 13.5 25.2277Z",
    fill: "#E50922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.458c3dbce21029f7a7af8a4a5ab3b5a7.svg";
export { ForwardRef as ReactComponent };